import React, { Component } from 'react';
import { connect } from "react-redux";
import "./style.scss";

// reactstrap imports
import {
  Jumbotron, Container, InputGroup, InputGroupText, InputGroupAddon, Input,
} from 'reactstrap';

class ConnectedGameList extends Component {

  render() {
    // const { games } = this.props;

    return (
      <div>

        <Jumbotron fluid className="gamelist-jumbotron-container">
          <Container fluid>
            <h1 className="display-3">Steam librairie</h1>
            <p className="lead">Découvrez toutes les nouveautés du moment !</p>
          </Container>
        </Jumbotron>

        <InputGroup className="gamelist-search-container">
          <Input className="input-text" placeholder="Rechercher dans le magasin" />

          <InputGroupAddon addonType="append">
            <InputGroupText className="gamelist-search-icon">

              <img src="https://res.cloudinary.com/djrdn2vgg/image/upload/v1591879760/SteamProject/searchicon_zcejiw.png" alt="search-icon" className="search-icon" />

            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>

        <div>
          Game List in progress !
        </div>

      </div>
    );
  }
}

const mstp = state => {
  return {
    games: state.gameInfo.game,
  };
};

const GameList = connect(
  mstp
)(ConnectedGameList);

export default GameList;